import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { findOrderEnumNames } from "@saleor/intl";
import { DialogProps } from "@saleor/types";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles(
  {
    buttonConfirm: {
      backgroundColor: "#FFD15C !important",
      marginLeft: "8px"
    },
    buttonDisabled: {
      backgroundColor: "#A1A1A1 !important"
    },
    contentText: {
      fontSize: "17px",
      fontWeight: 400
    },
    dialogContent: {
      display: "flex",
      flexDirection: "row",
      width: "100%"
    },
    textField: {
      marginTop: "20px",
      width: "100%"
    }
  },
  {
    name: "StoreOrderOverrideDialog"
  }
);

interface StoreOrderOverrideDialogProps extends DialogProps {
  onSubmitOverride: (reason) => void;
  orderStatus: string;
  newOrderStatus: string;
}

const StoreOrderOverrideDialog: React.FC<StoreOrderOverrideDialogProps> = props => {
  const {
    onClose,
    open,
    onSubmitOverride,
    orderStatus,
    newOrderStatus
  } = props;
  const classes = useStyles(props);

  const [reason, setReason] = React.useState("");

  return (
    <Dialog
      onClose={() => {
        onClose();
        setReason("");
      }}
      open={open}
      maxWidth="xs"
      fullWidth
    >
      <>
        <DialogTitle>Override Status</DialogTitle>
        <DialogContent>
          <div className={classes.dialogContent}></div>
          <span className={classes.contentText}>
            Are you sure you want to override the status of this order from{" "}
            <b>{findOrderEnumNames(orderStatus)}</b> to{" "}
            <b>{findOrderEnumNames(newOrderStatus)}</b>? If so, please state
            reason for override.
          </span>
          <TextField
            label="Reason for Override"
            className={classes.textField}
            multiline
            rows={6}
            value={reason}
            onChange={e => setReason(e.target.value)}
          ></TextField>
        </DialogContent>
        <DialogActions>
          <div>
            <Button
              autoFocus
              onClick={() => {
                onClose();
                setReason("");
              }}
              color="secondary"
            >
              Cancel
            </Button>
            <Button
              autoFocus
              disabled={reason ? false : true}
              onClick={() => {
                onSubmitOverride(reason);
                onClose();
                setReason("");
              }}
              color="primary"
              variant="contained"
              className={classNames({
                [classes.buttonConfirm]: reason,
                [classes.buttonDisabled]: !reason
              })}
            >
              Override
            </Button>
          </div>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default StoreOrderOverrideDialog;
